// extracted by mini-css-extract-plugin
module.exports = {"MainTitle":"WishList_MainTitle__1gQW5"};